import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Group, Stack, Text } from '@mantine/core';

import {
  ARRIVED,
  CREATED,
  PROCESSING,
  SAMPLED,
  sampleMetricDisplayNames,
  SHIPPED,
} from 'constants/dispatch';

import { getDispatchDisplayData } from 'util/dispatch';
import { DispatchType } from 'store/dispatch/types';

type DispatchExpandedRowPropsType = {
  dispatchPlan: DispatchType;
};

export const DispatchExpandedRow = ({ dispatchPlan }: DispatchExpandedRowPropsType) => {
  const { t, i18n } = useTranslation();

  const { assignedTo, assignedToScan, created, eta, readyToSample, status, updated } =
    getDispatchDisplayData(dispatchPlan, t, i18n.language);

  const generateDataDisplay = (label: string, data: any) => (
    <Group key={label} gap="0.25rem">
      <Text fw="bold" size="sm">
        {t(label)}:
      </Text>
      <Text size="sm">{data}</Text>
    </Group>
  );

  return (
    <Stack gap="xs" bg="grey.5" px="md" py="xs">
      <Group gap="lg">
        {Object.entries({ created, updated, readyToSample }).map(([label, data]) =>
          generateDataDisplay(label, data),
        )}
      </Group>
      <Divider color="grey.4" />
      <Stack>
        <Group gap="lg">
          {Object.entries({ status, assignedTo, assignedToScan, eta }).map(([label, data]) =>
            generateDataDisplay(label, data),
          )}
        </Group>
        <Group gap="lg">
          {[CREATED, SAMPLED, SHIPPED, ARRIVED, PROCESSING].map((metric) =>
            generateDataDisplay(
              sampleMetricDisplayNames[metric],
              `${dispatchPlan.sample_metrics[metric]}/${dispatchPlan.sample_metrics.total}`,
            ),
          )}
        </Group>
      </Stack>
    </Stack>
  );
};
